module.exports = __webpack_public_path__ + "static/step_3-2bd18b7c18e74e9c9e7c5c2a73ebac0f.png";